module.exports = __webpack_public_path__ + "img/Lantai Licin Kotor Icon.822a67ac.png";